import {
  faGraduationCap as solidGraduationCap,
  faNotdef as solidNotDef,
} from "@fortawesome/pro-regular-svg-icons";
import { faBullseyeArrow as solidBullseyeArrow } from "@fortawesome/pro-duotone-svg-icons";
import {
  faGraduationCap as lightGraduationCap,
  faNotdef as lightNotDef,
  faBullseyeArrow as lightBullseyeArrow,
} from "@fortawesome/pro-light-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import TaskTypeIcon from "../types/dtos/tasks/advanced-tasks/ClientTaskTypeIcon";

export const taskTypeIconHelper = {
  getTaskTypeIcon(
    taskTypeIcon: TaskTypeIcon,
    iconStyle: "REGULAR" | "LIGHT" = "REGULAR"
  ): IconDefinition {
    switch (taskTypeIcon) {
      case "GOALS":
        return iconStyle === "REGULAR"
          ? solidBullseyeArrow
          : lightBullseyeArrow;
      case "DEVELOPMENT":
        return iconStyle === "REGULAR"
          ? solidGraduationCap
          : lightGraduationCap;
      default:
        return iconStyle === "REGULAR" ? solidNotDef : lightNotDef;
    }
  },
};

export default taskTypeIconHelper;
